import { lazy, Suspense } from "react";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import Footer from "@/components/landing/Footer";

// Lazy load below-the-fold sections to improve FCP
const Problem = lazy(() => import("@/components/landing/Problem"));
const Services = lazy(() => import("@/components/landing/Services"));
const HowItWorks = lazy(() => import("@/components/landing/HowItWorks"));
const Industries = lazy(() => import("@/components/landing/Industries"));
const Benefits = lazy(() => import("@/components/landing/Benefits"));
const Testimonials = lazy(() => import("@/components/landing/Testimonials"));
const FAQ = lazy(() => import("@/components/landing/FAQ"));
const Contact = lazy(() => import("@/components/landing/Contact"));

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main>
        <Hero />
        <Suspense fallback={null}>
          <Problem />
          <Services />
          <HowItWorks />
          <Industries />
          <Benefits />
          <Testimonials />
          <FAQ />
          <Contact />
        </Suspense>
      </main>
      <Footer />
    </div>
  );
};

export default Index;
